export function getIconUrlBySubtype(subtype) {
  return '/poi/icons/' + subtype + '.svg'
}